import React, { useEffect, useState } from "react";
import "../style.css";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import uuidv4 from "uuid/v4";

const Option = Select.Option;

const AliquoteFields = ({
  article,
  articleId,
  contoId,
  setCurrentItem,
  index,
  changeArticle,
  setDrawerNature,
  natureVal,
  setNatureVal,
  isDocument,
  onArticleChange,
  isAccountRow,
  isSplitModal = false
}) => {

  const dispatch = useDispatch();
  const exemptionNatures = useSelector(state => state.precog.vat.exemptionNatures.list);

  const [aliquota, setAliquota] = useState("22%");

  const aliquote = ["0.0", "4.0", "5.0", "10.0", "22.0"];

  useEffect(() => {
    if (!article?.vatRate) return;
    setAliquota(article?.vatRate + "%");
  }, [article?.vatRate]);

  useEffect(() => {
    if (!article?.exemptionNature) return;
    let natures = natureVal;
    if (natureVal.find(el => el.article === article?.uuid)) {
      natures = natureVal.map(el => {
        if (el.article === article?.uuid) {
          return {...el, nature: article?.exemptionNature, natureId: article?.exemptionNatureId};
        }
        return el;
      });
    } else {
      natures.push({ article: article?.uuid, nature: article?.exemptionNature, natureId: article?.exemptionNatureId });
    }
    setNatureVal(natures);
  }, [article?.exemptionNature]);

  const onExemptionNatureIdChange = value => {
    const currentNature = exemptionNatures.find(el => el.id === value);
    changeArticle({ uuid: article?.uuid, type: ["exemptionNatureId", "exemptionNature"], value: [value, currentNature.nature] }, index);
    let natures = natureVal;
    if (natureVal.find(el => el.article === article?.uuid)) {
      natures = natureVal.map(el => {
        if (el.article === article?.uuid) {
          return {...el, nature: currentNature.nature, natureId: value};
        }
        return el;
      });
    } else {
      natures.push({ article: article?.uuid, nature: currentNature.nature, natureId: value });
    }
    setNatureVal(natures);
  };

  useEffect(() => {
    if (!natureVal) return;
    renderFirstNatureOptions();
  }, [natureVal]);
  
  const renderFirstNatureOptions = () => {
    let items = [];
    const currentNature = natureVal?.find(el => el.article === article?.uuid);
    const findRate = exemptionNatures?.find(x => x.nature === currentNature?.nature);
    exemptionNatures?.map(it => {
      if (findRate && findRate.nature === it.nature) {
        items.push(<Option
          key={"articles-accordion-select_" + uuidv4()}
          style={{background: currentNature?.natureId === it.id ? "#f2f5f8" : "initial"}}
          value={it.id}
          label={`0% - ${it.nature}`}
        >
          {`${it.nature} - ${it.description}`}
        </Option>);
      }
      return null;
    });
    return items;
  };

  return (
    // <DropTarget targetKey="precog-articles-drag"></DropTarget>
    <>
      <Select
        data-testid={"AliquoteFields"}
        showSearch
        value={isDocument ? article.vatRate === "0.0" ? `0.0% - ${article.exemptionNature}` : `${aliquota}` : natureVal?.find(el => el.article === article?.uuid)?.nature ? `0% - ${natureVal?.find(el => el.article === article?.uuid)?.nature}` : "0.0%"}
        style={{
          width: "100%"
        }}
        dropdownClassName={isAccountRow ? isDocument ? "articles-accordion-select-container" : "articles-accordion-select-dropdown natureSelect" : "split-article-input-accordion"}
        placeholder={"Seleziona aliquota"}
        optionFilterProp="children"
        className={isAccountRow ? "articles-accordion-select" : "split-article-input"}
        getPopupContainer={trigger => isAccountRow ? document.querySelector(".ant-table-tbody") : trigger.parentNode}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onSelect={(val) => {
          if (val === "0.0" || (!isDocument && val === "")) {
            setCurrentItem({
              currentLine: contoId,
              currentArticle: article
            });
            setDrawerNature({ rowId: articleId ? articleId : article.rowKey, index, article, isSplitModal: isSplitModal });
          }
          if (isDocument) {
            setAliquota(val + "%");
            onArticleChange("vatRate", val);
            dispatch({ type: "STOP_ACCOUNTS_REFRESH" });
          } else if (val !== "") {
            onExemptionNatureIdChange(val);
          }
        }}
      >
        {isDocument && aliquote.map((el, key) =>
          <Option
            key={"articles-accordion-select_" + key}
            value={el}
          >
            {`${el}%`}
          </Option>)}
        {!isDocument && renderFirstNatureOptions()}
        {!isDocument && <Option
          key={"articles-accordion-select_" + uuidv4()}
          value=""
        >
          <div className="articles-nature-select-showAll">
              Vedi tutti
          </div>
        </Option>}
      </Select>
    </>
  );
};

export default AliquoteFields;
